import { WidgetType } from '../widgets/widget-interfaces.model';
import { ChartOrientationType } from '../plotly/plotly-chart.model';

export class NewDashbordModel {
    uuid: string;
    name: string;
    deleted?: number;
    widgets: NewWidgetsModel[];
    constructor(newUUID: string, newName: string, newWidgets: NewWidgetsModel[]) {
        this.uuid = newUUID;
        this.name = newName;
        this.widgets = newWidgets;
    }
}
export class NewWidgetsModel {
    uuid: string;
    name: string;
    widgetType: WidgetType;
    devices: DevicesModel[];
    dataType: DataTypeModel[];
    dataTypeGrouped?: DataTypeModel[];
    period?: any;
    min?: number;
    max?: number;
    limit?: number;
    x: number;
    y: number;
    cols: number;
    rows: number;
    relationUuid: string;
    orientation: ChartOrientationType;
}
export class DevicesModel {
    uuid: string;
    name: string;
}
export class DataTypeModel {
    uuid: string;
    name: string;
    nombre_es: string;
    nombre_en: string;
    unity: string;
    codigo: string;
}
